import * as React from 'react';
import { formatPhone, SupportContactsWidget, SupportContactsWidgetItemLink } from '@cian/frontend-e2e-deal-component';
import { IconPhone16, IconTelegram16 } from '@cian/ui-kit';

import { trackDesktopChatVisible, trackDesktopChatClose } from './tracking';
import { useApplicationContext } from '../../utils/applicationContext';
import { ISupportContactsData } from './types';
import { NBSP } from '../../constants/symbols';

export const ChatContainer: React.FC = () => {
  const { config } = useApplicationContext();
  const supportContacts = config.get<ISupportContactsData>('e2e-deal-sale.supportContacts');

  const handleOpen = () => {
    trackDesktopChatVisible();
  };

  const handleClose = () => {
    trackDesktopChatClose();
  };

  if (!supportContacts) {
    return null;
  }

  const formattedPhone = formatPhone({
    phone: supportContacts.phone,
    template: `$1${NBSP}$2${NBSP}$3-$4-$5`,
  });

  return (
    <SupportContactsWidget
      onClose={handleClose}
      onOpen={handleOpen}
      heading={supportContacts.heading}
      description={supportContacts.description}
    >
      <SupportContactsWidgetItemLink href={`tel:${supportContacts.phone}`} icon={IconPhone16}>
        {`Горячая линия: ${formattedPhone}`}
      </SupportContactsWidgetItemLink>
      <SupportContactsWidgetItemLink
        href={supportContacts.telegram}
        icon={IconTelegram16}
        target="_blank"
        rel="noopener noreferrer"
      >
        Telegram чат поддержки
      </SupportContactsWidgetItemLink>
    </SupportContactsWidget>
  );
};

ChatContainer.displayName = 'ChatContainer';
